import * as api from '../../../clients/incidents';

import {Action} from '@ngrx/store';

export const POST_INCIDENT_VORLAGE_KOPIEREN_ADMIN = '[IncidentsModul] PostIncidentVorlageKopierenAdmin laden';
export const POST_INCIDENT_VORLAGE_KOPIEREN_ADMIN_AUSFUEHREN = '[IncidentsModul] PostIncidentVorlageKopierenAdmin ausführen';
export const POST_INCIDENT_VORLAGE_KOPIEREN_ADMIN_ERFOLGREICH = '[IncidentsModul] PostIncidentVorlageKopierenAdmin laden erfolgreich';
export const POST_INCIDENT_VORLAGE_KOPIEREN_ADMIN_FEHLER = '[IncidentsModul] PostIncidentVorlageKopierenAdmin Ladefehler';
export const POST_INCIDENT_VORLAGE_KOPIEREN_ADMIN_NICHT_AUSGEFUEHRT = '[IncidentsModul] PostIncidentVorlageKopierenAdmin nicht ausgeführt (evtl. Offline)';


export class PostIncidentVorlageKopierenAdminAction implements Action {
    readonly type = POST_INCIDENT_VORLAGE_KOPIEREN_ADMIN;
        constructor(public incidentVorlageRequest: api.IncidentVorlageRequest, public optPayload: any = null) {}
    }
export class PostIncidentVorlageKopierenAdminAusfuehrenAction implements Action {
    readonly type = POST_INCIDENT_VORLAGE_KOPIEREN_ADMIN_AUSFUEHREN;
        constructor(public incidentVorlageRequest: api.IncidentVorlageRequest, public optPayload: any = null) {}
    }
export class PostIncidentVorlageKopierenAdminErfolgreichAction implements Action {
    readonly type = POST_INCIDENT_VORLAGE_KOPIEREN_ADMIN_ERFOLGREICH;
        constructor(public payload: api.IncidentVorlageIdentifier, public incidentVorlageRequest: api.IncidentVorlageRequest, public optPayload: any = null) {}
    }
export class PostIncidentVorlageKopierenAdminFehlerAction implements Action {
    readonly type = POST_INCIDENT_VORLAGE_KOPIEREN_ADMIN_FEHLER;
        constructor(public payload: any, public incidentVorlageRequest: api.IncidentVorlageRequest, public optPayload: any = null) {}
    }
export class PostIncidentVorlageKopierenAdminNichtAusgefuehrtAction implements Action {
    readonly type = POST_INCIDENT_VORLAGE_KOPIEREN_ADMIN_NICHT_AUSGEFUEHRT;
        constructor(public optPayload: any = null) {}
    }
    

export type IncidentsCommandIncidentVorlageKopierenAdminActions =
    PostIncidentVorlageKopierenAdminAction
    | PostIncidentVorlageKopierenAdminAusfuehrenAction
    | PostIncidentVorlageKopierenAdminErfolgreichAction
    | PostIncidentVorlageKopierenAdminFehlerAction
    | PostIncidentVorlageKopierenAdminNichtAusgefuehrtAction
    ;
